import React, { useState } from "react";
import { connect } from "react-redux";
import { actions } from "../model";
import { canAdminUserUploadContent } from "../selectors";

import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

import MessageList from "./MessageList";
import TextArea from "react-textarea-autosize";

import css from "./styles.scss";

const decorate = connect(
  state => ({
    canAdminUserUploadContent: canAdminUserUploadContent(state)
  }),
  {
    sendComment: actions.sendComment
  }
);

const Comments = ({
  comments,
  isFirst = false,
  sendComment,
  idFileVersion,
  canAdminUserUploadContent,
  accentColor,
  viaPortal
}) => {
  if (!isFirst) {
    return null;
  }

  const useStyles = makeStyles(() => ({
    rootComponent: { margin: "0", marginRight: 20 },
    textFieldRoot: { flexGrow: 1, marginRight: 10 },
    sendButtonRoot: {
      width: 120,
      color: accentColor ? accentColor : undefined
    },
    sendButtonText: { textTransform: "capitalize" },
    sendMessageSection: {
      display: "flex",
      flexDirection: "row",
      alignContent: "center",
      justifyContent: "space-between",
      marginBottom: 10
    }
  }));

  const [newComment, setNewComment] = useState("");
  const classes = useStyles();
  const send = () => {
    sendComment({ newComment, idFileVersion });
    setNewComment("");
  };
  return (
    <div
      className={classes.rootComponent}
      style={!isFirst ? { marginLeft: viaPortal ? 12 : 40 } : {}}
    >
      {comments &&
        comments.map(comment => <MessageList comment={comment} space />)}

      {canAdminUserUploadContent ? (
        <div className={css.sendMessageSection}>
          <TextArea
            aria-label="Enter your comment"
            placeholder="Enter your comment"
            onChange={e => setNewComment(e.target.value)}
            maxRows={3}
            value={newComment}
            style={{
              width: "100%",
              border: "1px solid #ccc",
              borderRadius: 4,
              padding: "8px 8px",
              flexGrow: 1,
              marginRight: 10
            }}
          />
          <Button
            size="small"
            variant="outlined"
            color="primary"
            classes={{
              root: classes.sendButtonRoot,
              label: classes.sendButtonText
            }}
            disabled={!newComment}
            onClick={send}
          >
            Add Comment
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default decorate(Comments);
